<template>
  <div class="gap-8 w-full md:col-span-3">
    <h3 class="font-semibold mb-2">Personal & Business Details</h3>
    <div class="w-full space-y-4 bg-white rounded-md border border-gray p-5">
      <div class="space-y-14">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <img
                :src="personalAndBusinessDetails.personal_details.photo ? getS3URL(personalAndBusinessDetails.personal_details.photo) : 'https://randomuser.me/api/portraits/men/10.jpg'"
                alt="Avatar"
                class="w-18 h-18 rounded-full object-cover"
                @error="handleImgError"
            />
            <div class="flex flex-col gap-1">
              <h4 class="font-semibold">Profile Picture</h4>
              <h4 class="font-normal">PNG, JPG, GIF under 15MB.</h4>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <button class="text-h5 font-normal px-3 py-1 bg-primary text-white rounded-sm flex items-center gap-1">
              <Upload/>
              Upload Image
            </button>
            <button class="text-h5 font-normal px-3 py-1 text-primary border border-grey rounded-sm flex items-center gap-1">
              <Delete/>
              Delete
            </button>
          </div>
        </div>

        <div class="flex flex-col gap-6">
          <div class="flex items-center gap-6 w-full">
            <div class="w-1/2">
              <label class="text-h5 font-sm block font-archivo text-primary mb-1">First Name</label>
              <input
                  type="text"
                  class="text-paragraph w-full border px-4 py-2 rounded-md text-primary font-archivo"
                  placeholder="John"
                  :value="personalAndBusinessDetails.personal_details.first_name || ''"
              />
            </div>
            <div class="w-1/2">
              <label class="text-h5 font-sm block font-archivo text-primary mb-1">Last Name</label>
              <input
                  type="text"
                  class="border w-full px-4 py-2 rounded-md text-primary font-archivo text-paragraph"
                  placeholder="Doe"
                  :value="personalAndBusinessDetails.personal_details.last_name || ''"
              />
            </div>
          </div>

          <div class="flex items-center gap-6 w-full">
            <div class="w-1/2">
              <RoleDropdown
                v-model="personalAndBusinessDetails.personal_details.role"
              />
            </div>
            <div class="w-1/2">
              <label class="text-h5 font-sm block font-archivo text-primary mb-1">Starting Price (USD)</label>
              <input
                type="number"
                class="border w-full px-4 py-2 rounded-md text-primary font-archivo text-paragraph"
                placeholder="85"
                :value="personalAndBusinessDetails.personal_details.starting_price_usd || ''"
              />
            </div>
          </div>

          <div class="flex items-center gap-6 w-full">
            <div class="w-1/2">
              <CountryDropdown
                v-model="personalAndBusinessDetails.personal_details.location"
              />

            </div>
            <div class="w-1/2">

              <TimezoneDropdown
                v-model="personalAndBusinessDetails.personal_details.timezone"
              />
<!--              <label class="block text-h5 font-sm font-archivo text-primary mb-1">Timezone</label>-->
<!--              <select class='w-full border px-4 py-2 rounded-md text-primary' :value="personalAndBusinessDetails.personal_details.timezone || ''">-->
<!--                <option disabled value="">Select Timezone</option>-->
<!--                <option value="GMT (-3:00)">GMT (-3:00)</option>-->
<!--                <option value="GMT (-1:00)">GMT (-1:00)</option>-->
<!--              </select>-->
            </div>
          </div>

          <div>
            <label class="text-h5 font-sm block font-archivo text-primary mb-1">Business address</label>
            <input
              type="text"
              class="border w-full px-4 py-2 rounded-md text-primary font-archivo text-paragraph"
              placeholder="Enter business address"
              :value="personalAndBusinessDetails.personal_details.business_address || ''"
            />
          </div>

          <div>
            <label class="block text-h5 font-sm font-archivo text-primary mb-1" for="bio">Short Bio</label>
            <textarea
              id="bio"
              rows="4"
              placeholder="Write a short bio about yourself..."
              class="w-full border border-grey rounded-md px-4 py-2 text-paragraph text-primary font-archivo"
              :value="personalAndBusinessDetails.personal_details.short_bio || ''"
            ></textarea>
          </div>

          <div class="flex items-center gap-6 w-full">
            <div class="w-1/2">
              <div class="flex justify-between items-center mb-1">
                <div class="flex items-center gap-2">
                  <Lock />
                  <label class="text-h5 font-sm font-archivo text-primary">Website</label>
                </div>
                <div class="flex items-center bg-primary text-white rounded-md px-2 py-[2px] text-xs font-semibold">
                  LOCKED
                </div>
              </div>
              <input
                type="text"
                class="text-paragraph w-full border px-4 py-2 rounded-md text-primary font-archivo"
                :value="personalAndBusinessDetails.personal_details.website || ''"
              />
            </div>
            <div class="w-1/2">
              <div class="flex justify-between items-center mb-1">
                <div class="flex items-center gap-2">
                  <Lock />
                  <label class="text-h5 font-sm font-archivo text-primary">Phone number</label>
                </div>
                <div class="flex items-center bg-primary text-white rounded-md px-2 py-[2px] text-xs font-semibold">
                  LOCKED
                </div>
              </div>
              <input
                type="text"
                placeholder="Enter your phone number"
                class="text-paragraph w-full border px-4 py-2 rounded-md text-primary font-archivo"
                :value="personalAndBusinessDetails.personal_details.phone_number || ''"
              />
            </div>
          </div>

          <h5 class="font-medium">Other Links</h5>
          <div v-for="field in otherLinksData" :key="field.key" class="mt-4">
            <div class="flex justify-between items-center mb-1">
              <div class="flex items-center gap-2">
                <Lock />
                <label class="text-h5 font-sm font-archivo text-primary">{{ field.label }}</label>
              </div>
              <div class="flex items-center bg-primary text-white rounded-md px-2 py-[2px] text-xs font-semibold">
                LOCKED
              </div>
            </div>
            <input
              :placeholder="'Enter your ' + field.label.toLowerCase() + ' URL'"
              type="text"
              class="text-paragraph w-full border px-4 py-2 rounded-md text-primary font-archivo"
              :value="field.value || ''"
            />
          </div>

          <div>
            <SearchableMultiDropdown
                v-model="personalAndBusinessDetails.regions_served"
                label="Regions Served"
                placeholder="Select or search regions"
                data-type="regions"
                api-endpoint="https://restcountries.com/v3.1/all?fields=region,subregion"
                :max-selections="3"
            />
          </div>
          <div>
            <SearchableMultiDropdown
                v-model="personalAndBusinessDetails.languages"
                label="Languages"
                placeholder="Select languages you speak"
                api-endpoint="https://libretranslate.com/languages"
                option-key="code"
                option-display="name"
                :max-selections="5"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Upload from "../../assets/icons/upload.svg"
import Delete from "../../assets/icons/delete.svg"
import Lock from "../../assets/icons/lock.svg"
import type {PersonalAndBusinessDetails} from '@/types.ts'
import {computed} from "vue";
import {getS3URL, handleImgError} from "@/utils/helpers.ts";
import CountryDropdown from "@/components/common/InputFields/CountryDropdown.vue";
import RoleDropdown from "@/components/common/InputFields/RoleDropdown.vue";
import TimezoneDropdown from "@/components/common/InputFields/TimezoneDropdown.vue";
import SearchableMultiDropdown from "@/components/common/InputFields/SearchableMultiDropdown.vue";

interface Props {
  personalAndBusinessDetails: PersonalAndBusinessDetails;
}

const props = defineProps<Props>()

const otherLinksData = computed(() => [
  {
    key: 'linkedin_profile',
    label: "Linkedin profile",
    value: props.personalAndBusinessDetails.other_links.linkedin_profile,
  },
  {
    key: 'github_profile',
    label: "Github profile",
    value: props.personalAndBusinessDetails.other_links.github_profile,
  },
  {
    key: 'x_profile',
    label: "X profile",
    value: props.personalAndBusinessDetails.other_links.x_profile,
  },
  {
    key: 'fiverr_profile',
    label: "Fiverr profile",
    value: props.personalAndBusinessDetails.other_links.fiverr_profile,
  },
  {
    key: 'upwork_profile',
    label: "Upwork profile",
    value: props.personalAndBusinessDetails.other_links.upwork_profile,
  },
])
</script>